import { SectionShell, Field } from "./SectionShell";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { PRIMARY_GOALS, BUDGETS, inputCls } from "./constants";

export default function GoalsTab({ data, update, onVoice }) {
  const setGoals = (key, value) => update({ goals: { ...data.goals, [key]: value } });
  return (
    <SectionShell eyebrow="Section 4 · 5 min" title="Goals & Priorities" voiceSection="goals" onVoice={onVoice}>
      <div className="space-y-6">
        <Field label="Primary Goal">
          <RadioGroup value={data.goals?.primary_goal || ""} onValueChange={(v) => setGoals("primary_goal", v)} className="grid md:grid-cols-3 gap-3">
            {PRIMARY_GOALS.map((g) => (
              <label key={g} className="flex items-center gap-2 bg-ivory border border-navy/10 p-3 cursor-pointer hover:border-gold">
                <RadioGroupItem value={g} id={`pg-${g}`} data-testid={`goal-${g}`} /> <span className="text-sm text-navy">{g}</span>
              </label>
            ))}
          </RadioGroup>
        </Field>

        <div className="pt-2 border-t border-navy/10">
          <div className="eyebrow text-gold mb-2 mt-4">30 / 60 / 90 Day Goals</div>
          <p className="text-xs text-navy/60 mb-5">These drive the Intake Brief, Sprint Charter milestones, and Proposal Notes success metrics.</p>
          <div className="grid md:grid-cols-3 gap-5">
            <Field label="30 days — what does success look like?">
              <Textarea data-testid="goals-30" className={inputCls} rows={3} value={data.goals?.goals_30_day || ""}
                onChange={(e) => setGoals("goals_30_day", e.target.value)}
                placeholder="Tangible outcome in the first 30 days." />
            </Field>
            <Field label="60 days">
              <Textarea data-testid="goals-60" className={inputCls} rows={3} value={data.goals?.goals_60_day || ""}
                onChange={(e) => setGoals("goals_60_day", e.target.value)}
                placeholder="What changes between day 30 and 60." />
            </Field>
            <Field label="90 days">
              <Textarea data-testid="goals-90" className={inputCls} rows={3} value={data.goals?.goals_90_day || ""}
                onChange={(e) => setGoals("goals_90_day", e.target.value)}
                placeholder="The end-state outcome." />
            </Field>
          </div>
          <div className="mt-5">
            <Field label="Primary success metrics — what numbers will tell you this worked?">
              <Input data-testid="goals-metrics" className={inputCls} value={data.goals?.primary_metrics || ""}
                onChange={(e) => setGoals("primary_metrics", e.target.value)}
                placeholder="e.g. leads/month, speed-to-lead, close rate, hours saved per week, MRR." />
            </Field>
          </div>
        </div>

        <Field label="What would you do with an extra 5–10 hours per week?">
          <Textarea data-testid="goals-extra-time" className={inputCls} rows={2} value={data.goals?.extra_time_use || ""}
            onChange={(e) => setGoals("extra_time_use", e.target.value)} />
        </Field>
        <Field label="Any upcoming changes creating urgency?">
          <Textarea data-testid="goals-urgency" className={inputCls} rows={2} value={data.goals?.upcoming_changes || ""}
            onChange={(e) => setGoals("upcoming_changes", e.target.value)} />
        </Field>
        <Field label="Budget Sensitivity">
          <RadioGroup value={data.goals?.budget_sensitivity || ""} onValueChange={(v) => setGoals("budget_sensitivity", v)} className="grid md:grid-cols-3 gap-3">
            {BUDGETS.map((b) => (
              <label key={b} className="flex items-center gap-2 bg-ivory border border-navy/10 p-3 cursor-pointer hover:border-gold">
                <RadioGroupItem value={b} id={`bs-${b}`} data-testid={`budget-${b}`} /> <span className="text-sm text-navy">{b}</span>
              </label>
            ))}
          </RadioGroup>
        </Field>
      </div>
    </SectionShell>
  );
}
